import MappingProgramProcessPopup from './MappingProgramProcessPopup';

export default {
    MappingProgramProcessPopup,
};

export {
    MappingProgramProcessPopup,
};